// 숫자 카드: GET /inquiries/summary(거르기와 무관한 전체 기준)를 그대로 보인다.
const SUB = {
    new: ["새로 들어온 문의", "var(--st-new)"],
    processing: ["담당자가 진행 중", "var(--st-ing)"],
    on_hold: ["가맹점 회신 대기 등", "var(--st-hold)"],
    completed: ["처리 끝난 문의", "var(--st-done)"],
    canceled: ["챗봇이 해결 · 중복 등", "var(--st-cancel)"],
};

export default function StatsCards({ summary, meta, filter, onPickStatus, onPickUnassigned }) {
    const only = filter.statuses && filter.statuses.length === 1 ? filter.statuses[0] : null;
    const by = summary?.by_status || {};
    return (
        <div className="stats">
            {(meta?.statuses || []).map((s) => (
                <button key={s.code} className={`stat ${only === s.code ? "on" : ""}`} onClick={() => onPickStatus(s.code)}>
                    <div className="stat-l"><span className="sw" style={{ background: SUB[s.code]?.[1] }}></span>{s.label}</div>
                    <div className="stat-n">{by[s.code] || 0}</div>
                    <div className="stat-sub">{SUB[s.code]?.[0]}</div>
                </button>
            ))}
            <button className={`stat stat-warn ${filter.assignee === "none" ? "on" : ""}`} onClick={onPickUnassigned}>
                <div className="stat-l"><span className="sw" style={{ background: "var(--red)" }}></span>담당자 미지정</div>
                <div className="stat-n">{summary?.unassigned_open || 0}</div>
                <div className="stat-sub">{summary?.unassigned_late ? `그중 2시간 넘은 건 ${summary.unassigned_late}건` : "배정이 필요한 문의"}</div>
            </button>
        </div>
    );
}
